module.exports = __webpack_public_path__ + "img/material.fa4e7deb.png";